import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import classnames from 'classnames'

import { branch } from 'baobab-react/higher-order'
import API, { axios } from 'utils/API'
import buildUrl from 'utils/buildUrl'
import storage from 'utils/storage'
import LayoutContext from 'utils/ui/LayoutContext'
import isDOMAvailable from 'utils/isDOMAvailable'

import BaseTemplate from 'components/templates/BaseTemplate'
import {
  Container,
  Row,
} from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import DropdownFilter from 'components/molecules/DropdownFilter'
import Thumbnails from 'components/organisms/Thumbnails'

class Majors extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      page: 1,
      selectedFilter: '',
      isLastPage: props.isLastPage,
      isLoading: false,
      sticky: false,
      bannerHeight: 0,
      breadcrumbHeight: 0,
      navbarHeight: 0,
    }

    this.getMajors = this.getMajors.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.loadMore = this.loadMore.bind(this)
  }

  componentDidMount() {
    if (isDOMAvailable) {
      const breadcrumbHeightVal = document.querySelector('.Breadcrumb') && document.querySelector('.Breadcrumb').offsetHeight
      const navbarHeightVal = document.querySelector('.navbar') && document.querySelector('.navbar').offsetHeight
      this.setState({ breadcrumbHeight: breadcrumbHeightVal, navbarHeight: navbarHeightVal })
      document.querySelector('.promotion-banner__banner') && document.querySelector('.promotion-banner__banner').addEventListener('load', this.getHeight)
      window.addEventListener('scroll', this.toggleSticky)
    }
  }

  getMajors(action = 'filter') {
    const { page, selectedFilter } = this.state
    const studyFieldsStorage = storage.select('serverProps', 'studyFields')

    if (action === 'filter') studyFieldsStorage.set([])
    this.setState({ isLoading: true })

    setTimeout(() => (
      axios({
        url: API.endPoints().majors,
        method: 'get',
        responseType: 'json',
        params: {
          page,
          parent_id: selectedFilter,
        },
      }).then((response) => {
        const studyFields = response.data.studyFields

        if (action === 'filter') {
          studyFieldsStorage.set(studyFields)
        } else {
          studyFieldsStorage.concat(studyFields)
        }

        this.setState({
          isLastPage: response.data.isLastPage,
          isLoading: false,
        })
      })
    ), 500)
  }

  toggleSticky = () => {
    const { sticky, bannerHeight, breadcrumbHeight, navbarHeight } = this.state
    const sectionHeight = bannerHeight + breadcrumbHeight + navbarHeight
    if (window.scrollY >= sectionHeight) {
      !sticky && this.setState({ sticky: true })
    } else {
      sticky && this.setState({ sticky: false })
    }
  }

  getHeight = (e) => {
    e.preventDefault()
    const { bannerHeight } = this.state
    if (bannerHeight !== e.target.offsetHeight) {
      this.setState({ bannerHeight: e.target.offsetHeight })
    }
  }

  handleChange(option) {
    this.setState({
      page: 1,
      selectedFilter: option.id,
    }, () => {
      this.getMajors()
      buildUrl({
        path: 'majors',
        queryParams: {
          filter: option.slug,
        },
      })
    })
  }

  loadMore() {
    const { page } = this.state
    this.setState({ page: page + 1 }, () => {
      this.getMajors('loadMore')
    })
  }

  render() {
    const {
      studyFields,
      filterOptions,
    } = this.props

    const {
      selectedFilter,
      isLastPage,
      isLoading,
      sticky,
    } = this.state

    return (
      <BaseTemplate useNewHeader>
        <LayoutContext.Consumer>
          {
            (navbarState) => {
              const pageHeaderClass = classnames('page-header', {
                'page-header--sticky': sticky && navbarState.fixedNavbar,
              })

              return (
                <div className={pageHeaderClass}>
                  <Container>
                    <Row>
                      <div className="col-md-4 col-sm-6">
                        <Typography component="h1" variant="title" className="text-variant-title-sm m-b-md">
                          {intl.get('containers.Majors.directory')}
                        </Typography>
                        <DropdownFilter
                          selectedOption={selectedFilter}
                          options={filterOptions}
                          onChange={this.handleChange}
                          labelText={intl.get('containers.Majors.filter_by_major')}
                          optionText={intl.get('containers.Majors.all_majors')}
                        />
                      </div>
                    </Row>
                  </Container>
                  <style jsx>
                    {`
                      .page-header {
                        &--sticky {
                          position: fixed;
                          z-index: 2;
                          top: ${navbarState.fixedNavbar ? `${navbarState.navbarHeight - 1}px` : 0};
                          width: 100%;
                        }
                      }
                    `}
                  </style>
                </div>
              )
          }}
        </LayoutContext.Consumer>

        <Thumbnails
          kind="studyFields"
          data={studyFields}
          isLoading={isLoading}
          isLastPage={isLastPage}
          loadMoreText={intl.get('containers.Majors.see_other_majors')}
          loadMoreFunction={this.loadMore}
        />
      </BaseTemplate>
    )
  }
}

Majors.propTypes = {
  studyFields: PropTypes.array.isRequired,
  filterOptions: PropTypes.array.isRequired,
  isLastPage: PropTypes.bool,
}

export { Majors }
export default branch({
  studyFields: ['serverProps', 'studyFields'],
  filterOptions: ['serverProps', 'filterOptions'],
  isLastPage: ['serverProps', 'isLastPage'],
}, Majors)
